






import { Component, Vue } from "vue-property-decorator";
import InputSEPSimple from "@/components/InputSEPSimple.vue";
import { storeDokter } from "@/store/modules/dokter";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";

@Component({
  components: {
    InputSEPSimple
  }
})
export default class InputSepSimplePage extends Vue {
  mounted() {
    if (!storeDokter.list.length || !storeDokter.listAll.length) {
      // storeDokter.act_dokter_all();
    }

    ReferensiUnit.getUnit();
  }
}
